














import { Component, Prop, Mixins } from "vue-property-decorator";
import { IBrandGateway } from "@/models/gateways";
import { SelectedPaymentMethodExternalStore } from "@/models/selectPaymentMethod";
import ExternalAuthMixin from "@/components/app/global/payments/externalAuthMixin.vue";
import { DataModules } from "@/store/modules/data";
import { GatewayTypesMap } from "@/data/enums/gateway";
import { Location as VueLocation } from "vue-router";
import { IClient } from "@/models/clients";
import { PaymentMethodType } from "@/models/selectPaymentMethod";

@Component
export default class ExternalStoreGateway extends Mixins(ExternalAuthMixin) {
  @Prop({ required: true })
  public readonly brandGateway!: IBrandGateway;

  @Prop({ required: true })
  public readonly externalAuthReturnLocation!: () => VueLocation;

  @Prop({ required: true })
  public readonly clientId!: IClient["id"];

  public isProcessing = false;
  public gatewayTypesMap = GatewayTypesMap();

  public created() {
    this.$emit("input", {
      type: PaymentMethodType.EXTERNAL_STORE
    } as SelectedPaymentMethodExternalStore);
  }

  public get i18n() {
    return {
      gatewayType: this.$_.lowerCase(
        this.gatewayTypesMap?.[this.brandGateway?.gateway?.type]?.label
      )
    };
  }

  public get returnLocationMaterialized() {
    return this.externalAuthReturnLocation();
  }

  public async setupExternalStore() {
    try {
      this.isProcessing = true;
      const returnRouteResolver = this.$router.resolve(
        // {} resolves to current route
        this.returnLocationMaterialized || {}
      );

      /**
       * This call doesn't create any payment details but returns approval_url that we have to redirect user to
       */
      const createPaymentDetailResult = await this.$store.dispatch(
        `data/${DataModules.CLIENTS_PAYMENT_DETAILS}/create`,
        {
          id: this.clientId,
          data: {
            gateway_id: this.brandGateway.gateway_id,
            return_url: `${location.origin}${returnRouteResolver.route.fullPath}`
          }
        }
      );
      this.redirectToExternalAuth({
        returnLocation: returnRouteResolver.location,
        url: createPaymentDetailResult.approval_url
      });
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.isProcessing = false;
    }
  }
}
